import * as actionTypes from '../actions/actionTypes'

const initialState = {
  banners: {
    banners: '',
    isLoading: false,
    isError: false
  },
  updatedBanner: {
    isLoading: false,
    isSuccess: false,
    isError: false
  },
  saveBanner: {
    isLoading: false,
    isSuccess: false,
    isError: false
  },
  updatedBannerPriority: {
    isLoading: false,
    isSuccess: false,
    isError: false
  }
}

const bannerReducer = (state = initialState, action = {}) => {
  const newState = { ...state }

  switch (action.type) {
    case actionTypes.GET_BANNERS:
      return { ...newState, banners: { ...newState.banners, isLoading: true } }

    case actionTypes.GET_BANNERS_SUCCESS:
      return { ...newState, banners: { banners: [...action.payload], isLoading: false, isError: false } }

    case actionTypes.GET_BANNERS_FAILURE:
      return { ...newState, banners: { isLoading: false, isError: true } }

    case actionTypes.UPDATE_BANNER:
      return { ...newState, updatedBanner: { ...newState.updatedBanner, isLoading: true } }

    case actionTypes.UPDATE_BANNER_SUCCESS:
      return { ...newState, updatedBanner: { isLoading: false, isSuccess: true, isError: false } }

    case actionTypes.UPDATE_BANNER_FAILURE:
      return { ...newState, updatedBanner: { isLoading: false, isSuccess: false, isError: true } }

    case actionTypes.UPDATE_BANNER_RESET:
      return { ...newState, updatedBanner: { isLoading: false, isSuccess: false, isError: false }, banners: { ...newState.banners, banners: '' } }

    case actionTypes.SAVE_BANNER:
      return { ...newState, saveBanner: { ...newState.saveBanner, isLoading: true } }

    case actionTypes.SAVE_BANNER_SUCCESS:
      return { ...newState, saveBanner: { isLoading: false, isSuccess: true, isError: false } }

    case actionTypes.SAVE_BANNER_FAILURE:
      return { ...newState, saveBanner: { isLoading: false, isSuccess: false, isError: true } }

    case actionTypes.SAVE_BANNER_RESET:
      return { ...newState, saveBanner: { isLoading: false, isSuccess: false, isError: false }, banners: { ...newState.banners, banners: '' } }

    case actionTypes.UPDATE_BANNER_PRIORITY:
      return { ...newState, updatedBannerPriority: { ...newState.updatedBannerPriority, isLoading: true } }

    case actionTypes.UPDATE_BANNER_PRIORITY_SUCCESS:
      return { ...newState, updatedBannerPriority: { isLoading: false, isSuccess: true, isError: false } }

    case actionTypes.UPDATE_BANNER_PRIORITY_FAILURE:
      return { ...newState, updatedBannerPriority: { isLoading: false, isSuccess: false, isError: true } }

    case actionTypes.UPDATE_BANNER_PRIORITY_RESET:
      return { ...newState, updatedBannerPriority: { isLoading: false, isSuccess: false, isError: false }, banners: { ...newState.banners, banners: '' } }

    default:
      return { ...newState }
  }
}

export default bannerReducer
